import { login, logout, getInfo, smsLogin } from '@/api/login';
import { getToken, setToken, removeToken } from '@/utils/auth';
// import defAva from '@/assets/images/profile.jpg';
import { defineStore } from 'pinia';
import { encrypt } from '@/utils/jsencrypt';

const useUserStore = defineStore('user', {
  state: (): {
    token?: string;
    name: string;
    phonenumber: string;
    phonenumberReal: string;
    avatar: string;
    roles: any[];
    permissions: string[];
    userId: any;
    nickName: string;
    currentDeptId: string;
    deptId?: string;
  } => ({
    token: getToken(),
    name: '',
    phonenumber: '',
    phonenumberReal: '',
    avatar: '',
    roles: [],
    permissions: [],
    userId: '',
    nickName: '',
    currentDeptId: '',
  }),

  actions: {
    // 设置token
    setToken(token: string) {
      this.token = token;
    },
    // 设置当前部门
    setCurrentDeptId(deptId: string) {
      this.currentDeptId = deptId;
    },
    // 登录
    login(userInfo: {
      username: string;
      password: string;
      code: string;
      uuid: string;
    }) {
      const username = userInfo.username.trim();
      // const password = userInfo.password;
      const password = encrypt(userInfo.password) as string;

      const code = userInfo.code;
      const uuid = userInfo.uuid;
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid)
          .then((res: any) => {
            setToken(res.token);
            this.token = res.token;
            this.getInfo();
            resolve(1);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    mobileLogin(userInfo: {
      mobile: string;
      code: string;
      uuid: string;
      smsCode: string;
      smsUuid: string;
    }) {
      const { code, uuid, smsCode, smsUuid } = userInfo;
      const mobile = encrypt(userInfo.mobile) as string;
      return new Promise((resolve, reject) => {
        smsLogin(mobile, code, uuid, smsUuid, smsCode)
          .then((res: any) => {
            setToken(res.token);
            this.token = res.token;
            this.getInfo();
            resolve(1);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 获取用户信息
    getInfo() {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res: any) => {
            const user = res.user;
            // const avatar =
            //   user.avatar === '' || user.avatar == null
            //     ? defAva
            //     : import.meta.env.VITE_APP_BASE_API + user.avatar;

            this.name = user.userName;
            // this.avatar = avatar;
            this.roles = user.roles;
            this.phonenumber = user.phonenumber;
            this.phonenumberReal = user.phonenumberReal;
            this.userId = user.userId;
            this.nickName = user.nickName;
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 退出系统
    logOut() {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            this.token = '';
            this.roles = [];
            this.permissions = [];
            removeToken();
            resolve(1);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
});

export default useUserStore;
